/* ══════════════════════════════════════════════════════════════════════
   Stellar · indicador de rolagem — o motor

   UM MOTOR, NÃO SEIS. Antes existiam três algoritmos de foco espalhados
   (borda de entrada com getBoundingClientRect, borda com offsetLeft, e
   centro da pista) e um deles ainda rodava atrás de setTimeout(110) — o
   ponto acendia quase meio segundo depois do dedo. Aqui só existe o
   primeiro, que é o mais novo dos três, sempre atrás de rAF.

   COMO ELE ACHA A PISTA
     Pelo id, nunca por caminho no DOM: `data-ind-para="algum-id"` no
     indicador, `id="algum-id"` na pista. Caminho no DOM é o que quebra
     quando alguém move um elemento — e mover elementos é o que mais
     acontece num tema.

   POR QUE É IDEMPOTENTE
     O arquivo pode ser incluído por mais de uma seção na mesma página.
     Duplicar <script src> não baixa duas vezes, mas EXECUTA duas vezes —
     e sem a trava abaixo cada indicador ganharia dois ouvintes.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__stlIndicador) return;
  window.__stlIndicador = 1;

  function achaPista(el) {
    var id = el.getAttribute('data-ind-para');
    return id ? document.getElementById(id) : null;
  }

  /* Qual item está encostado na borda de ENTRADA da pista.
     O atalho do fim existe porque o último item encaixa pela DIREITA:
     sem ele, o passo certo nunca acende no fim da rolagem. */
  function foco(pista, itens) {
    if (pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 2) return itens.length - 1;
    var pl = parseFloat(getComputedStyle(pista).paddingLeft) || 0;
    var borda = pista.getBoundingClientRect().left + pl;
    var melhor = 0, menor = Infinity;
    for (var k = 0; k < itens.length; k++) {
      var d = Math.abs(itens[k].getBoundingClientRect().left - borda);
      if (d < menor) { menor = d; melhor = k; }
    }
    return melhor;
  }

  function itensDe(pista) {
    var sel = pista.getAttribute('data-ind-itens');
    return [].slice.call(sel ? pista.querySelectorAll(sel) : pista.children);
  }

  /* ── contínua: largura = fatia visível, posição = fração rolada.
        É o mesmo cálculo que as duas barras vivas já faziam — não mexi
        numa vírgula dele, só parei de existir em quatro cópias. ── */
  function ligaContinua(ind, pista) {
    var cheio = ind.querySelector('b');
    if (!cheio) { cheio = document.createElement('b'); ind.appendChild(cheio); }
    function medir() {
      var max = pista.scrollWidth - pista.clientWidth;
      var vis = pista.clientWidth / pista.scrollWidth;
      var pct = max > 0 ? pista.scrollLeft / max : 0;
      var w = Math.max(vis * 100, 14);
      cheio.style.width = w + '%';
      cheio.style.transform = 'translateX(' + (pct * (100 / (w / 100) - 100)) + '%)';
    }
    var pedido = 0;
    pista.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = requestAnimationFrame(function () { pedido = 0; medir(); });
    }, { passive: true });
    addEventListener('resize', medir, { passive: true });
    medir();
    return { medir: medir };
  }

  /* ── segmentada: um passo por item ── */
  function ligaSegmentada(ind, pista) {
    var itens = itensDe(pista);
    if (!itens.length) return null;

    var clicavel = ind.hasAttribute('data-ind-clicavel');
    ind.innerHTML = '';
    for (var k = 0; k < itens.length; k++) {
      var p;
      if (clicavel) {
        p = document.createElement('button');
        p.type = 'button';
        p.className = 'stl-ind__passo';
        p.setAttribute('aria-label', 'Ir para o item ' + (k + 1));
        (function (j) {
          p.addEventListener('click', function () {
            var destino = itens[j].offsetLeft - itens[0].offsetLeft;
            try { pista.scrollTo({ left: destino, behavior: 'smooth' }); }
            catch (e) { pista.scrollLeft = destino; }
          });
        })(k);
      } else {
        p = document.createElement('i');
      }
      ind.appendChild(p);
    }
    var passos = [].slice.call(ind.children);
    var atual = -1;

    function pinta() {
      var k = foco(pista, itens);
      if (k === atual) return;
      atual = k;
      for (var j = 0; j < passos.length; j++) passos[j].classList.toggle('on', j === atual);
    }
    var pedido = 0;
    pista.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = requestAnimationFrame(function () { pedido = 0; pinta(); });
    }, { passive: true });
    addEventListener('resize', function () { atual = -1; pinta(); }, { passive: true });
    pinta();
    return { pinta: pinta };
  }

  function liga(ind) {
    var pista = achaPista(ind);
    if (!pista) return;
    if (ind.classList.contains('stl-ind--segmentada')) ligaSegmentada(ind, pista);
    else ligaContinua(ind, pista);
  }
  /* mede so quando a regua chega perto da tela: no DOMContentLoaded cada medida forcava o estilo da pagina inteira */
  var ioInd = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) return; ioInd.unobserve(e.target); var ind = e.target._stlInd; if (ind) liga(ind); });
  }, { rootMargin: '600px 0px' }) : null;
  function monta(ind) {
    if (ind.dataset.indPronto) return;
    var pista = achaPista(ind);
    if (!pista) return;
    ind.dataset.indPronto = '1';
    /* observa a pista, nao a regua: regua vazia pode estar display:none (.shv-dots:empty) e nunca cruzaria a tela */
    if (ioInd) { pista._stlInd = ind; ioInd.observe(pista); } else liga(ind);
  }

  function varre(raiz) {
    var r = raiz || document;
    if (r.matches && r.matches('[data-ind-para]')) return monta(r);
    [].slice.call(r.querySelectorAll('[data-ind-para]')).forEach(monta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { varre(); });
  } else { varre(); }

  /* O editor de tema redesenha a seção a cada tecla e o HTML novo volta
     sem ouvinte nenhum. Sem isto o indicador some no primeiro ajuste e a
     seção parece morta enquanto a pessoa edita. */
  document.addEventListener('shopify:section:load', function (e) { varre(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].slice.call(e.target.querySelectorAll('[data-ind-para]')).forEach(function (el) {
      delete el.dataset.indPronto;
    });
  });

  window.StellarIndicador = { montar: varre };
})();
